"use strict";

var React = require("react");

var Footer = React.createClass({
    render: function(){
        return (
            <div id="footer">
                ©2015 Búnaðarbankinn - <a href="#">Skilmálar</a> - <a href="#">Persónuvernd</a>
            </div>
        );
    }
});
module.exports = Footer;



// WEBPACK FOOTER //
// ./app/scripts/Footer.react.js